import { Sector } from '@/domain/impact/impact.entity';
import {
  BuildingHeatingType,
  BuildingHeatingValues,
  Category,
  ImpactCo2Answer,
  ValuesBuildingHeating,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'BUILDING_HEATING';
const SECTORS: Sector[] = ['SITE'];

export function mapToBuildingHeatingAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesBuildingHeating>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const buildingHeatingType = mapToBuildingHeatingType(row);
  const buildingSize = mapToBuildingSize(row);
  const numberOfMonthsOfUse = mapToNumberOfMonthsOfUse(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      buildingHeatingType,
      buildingSize,
      numberOfMonthsOfUse,
    },
  };
  return answer;
}

function mapToBuildingHeatingType(row: ImportedRow): BuildingHeatingType {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<BuildingHeatingType>(
    tgsValue,
    BuildingHeatingValues,
  );
  if (!result) {
    throw new ImportMappingError('buildingHeatingType', tgsValue, row);
  }
  return result;
}

function mapToBuildingSize(row: ImportedRow): number {
  const tgsValue = row['buildingSize'];
  const result = parseInt(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('buildingSize', tgsValue, row);
  }
  return result;
}

function mapToNumberOfMonthsOfUse(row: ImportedRow): number {
  const tgsValue = row['numberOfMonthsOfUse'];
  const result = parseInt(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('numberOfMonthsOfUse', tgsValue, row);
  }
  return result;
}
